import UIComponent from "../component";

export class RenewalBtn extends UIComponent {
    init() {
        this.includeComponents({
            renewal_modal: 'document@#RenewalModal'
        });

        this.on("click" , () => this.OpenCancelModal())

    }

    OpenCancelModal () {
        this.renewal_modal.show()
    }


}
